import { prefixObjectValues } from '../../utils';

const registrationForm = {
  legalEntityName: 'legal-entity-name',
  employerNpi: 'employer-npi',
  employerType: 'employer-type',
  ownershipStructure: 'ownership-structure',
  employerWebsite: 'employer-website',
  submitButton: 'submit-button',
  facilityName: 'facility-name',
  facilityNpi: 'facility-npi',
  clinicalSettingCategory: 'clinical-setting-category',
  clinicalSetting: 'clinical-setting',
  facilitySize: 'facility-size',
  areaType: 'area-type',
};

export default prefixObjectValues(registrationForm, 'registration-form');
